import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Howl } from 'howler';
import commonSoundProps from './commonSoundProps';
import SoundPlayer from './SoundPlayer';

const minLoopInterval = 2000;

export default class OrderSoundPlayer extends Component {
  constructor(props) {
    super(props);

    this.testSoundInstance = new Howl({
      ...commonSoundProps,
      volume: 0,
      onend: () => {
        props.onSoundPlayed();
      },
      onloaderror: (id, err) => {
        this.handleError(err);
      },
      onplayerror: (id, err) => {
        this.handleError(err);
      },
    });
  }

  componentDidMount() {
    this.testSoundInstance.play();
  }

  handleError = error => {
    const { onSoundFailed } = this.props;
    onSoundFailed(error);
  };

  render() {
    const { isSoundEnabled, loopInterval } = this.props;
    return (
      <SoundPlayer
        isSoundEnabled={isSoundEnabled}
        loopInterval={loopInterval >= minLoopInterval ? loopInterval : minLoopInterval}
        key={`${loopInterval}-${isSoundEnabled}`}
      />
    );
  }
}

const noop = () => {};

OrderSoundPlayer.defaultProps = {
  loopInterval: minLoopInterval,
  onSoundPlayed: noop,
  onSoundFailed: noop,
};

OrderSoundPlayer.propTypes = {
  isSoundEnabled: PropTypes.bool.isRequired,
  loopInterval: PropTypes.number,
  onSoundPlayed: PropTypes.func,
  onSoundFailed: PropTypes.func,
};



// WEBPACK FOOTER //
// ../ui-components/components/OrderSoundPlayer/OrderSoundPlayer.jsx